/**
 * Iter-231 — Default-switch router for /admin/home.
 *
 * Renders the new triage-first Admin Home V2 by default. Append `?classic=1`
 * to fall back to the legacy operational dashboard.
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminHome from './Home';
import HomeV2 from './HomeV2';

const AdminHomeRouter = () => {
  const [params] = useSearchParams();
  const useClassic = params.get('classic') === '1';
  return useClassic ? <AdminHome /> : <HomeV2 />;
};

export default AdminHomeRouter;
